import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { GerenciarPerfisUsuariosComponent } from './components/gerenciar-perfis-usuarios.component';
import { ListaUsuariosComponent } from './components/lista-usuarios/lista-usuarios.component';
import { EditarPapeisUsuarioComponent } from './components/editar-papeis-usuario/editar-papeis-usuario.component';
import { CriarPapelDialogComponent } from './components/editar-papeis-usuario/criar-papel-dialog/criar-papel-dialog.component';
import { EditarPermissoesPapelComponent } from './components/editar-permissoes-papel/editar-permissoes-papel.component';
import { PaineisSelecaoCheckboxesComponent } from './components/shared/paineis-selecao-checkboxes/paineis-selecao-checkboxes.component';
import { TrocarSenhaUsuarioDialogComponent } from './components/lista-usuarios/trocar-senha-usuario-dialog/trocar-senha-usuario-dialog.component';
import { GerenciarPerfisUsuariosApiService } from './services/gerenciar-perfis-usuarios-api.service';
import { GerenciarPerfisUsuariosResolver } from './gerenciar-perfis-usuarios.resolver';

@NgModule({
  declarations: [
    GerenciarPerfisUsuariosComponent,
    ListaUsuariosComponent,
    EditarPapeisUsuarioComponent,
    CriarPapelDialogComponent,
    EditarPermissoesPapelComponent,
    PaineisSelecaoCheckboxesComponent,
    TrocarSenhaUsuarioDialogComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    { provide: GerenciarPerfisUsuariosApiService, useClass: GerenciarPerfisUsuariosApiService },
    GerenciarPerfisUsuariosResolver,
  ],
})
export class GerenciarPerfisUsuariosModule { }
